module.exports = __webpack_public_path__ + "static/img/redbag_06@2x.378b61f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redbag_06@2x.png
// module id = Z7Q4
// module chunks = 0